const getters = {
    ticket: (state) => state.ticket,
    ticketId: (state) =>state.ticketId,
    loading: state => state.loading
};

export default getters;